import { useEffect, useState } from 'react';

export interface UseWindowSize {
    width: number;
    height: number;
}
const useWindowSize = (): UseWindowSize => {
    const [windowSize, setWindowSize] = useState<UseWindowSize>({
        width: 0,
        height: 0,
    });

    useEffect(() => {
        function handleResize() {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        }

        // Add event listener
        window.addEventListener('resize', handleResize);
        handleResize();

        return () => window.removeEventListener('resize', handleResize);
    }, []); // Empty array ensures that effect is only run on mount

    return windowSize;
};

export default useWindowSize;
